import React, { Fragment, useRef } from 'react';
import QuickSearch from './QuickSearch';
import { useSelector } from 'react-redux';
import NavigationItem from './NavigationItem';

const MobileMenu = ({ helpDeskUrl = "", addressInformation = "", ChannelsNamesAndUrls = [], renderMobileItems, logo = "" }) => {

    const contentLinks = useSelector((state) => state.navigation.contentLinks);

    return (
        <Fragment>
            <div className="header__row compact-header header__row--one-row">
            <a href="/" className="header__logo">
                <img src={logo}></img>
            </a>
                <div className="header__components">
                <QuickSearch></QuickSearch>
                    <div id="miniCart" className="cart cart--mini"></div>
            </div>
                <div className="header__break"></div>

                <nav id="navbar" role="navigation" className="navbar">
                    <NavigationItem links={contentLinks} helpDeskUrl={helpDeskUrl} addressInformation={addressInformation} ChannelsNamesAndUrls={ChannelsNamesAndUrls} logo={logo} renderMobileItems></NavigationItem>
                </nav>
            </div>
        </Fragment>
    )
};

export default MobileMenu;
